import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  sidebarButtonInfo: {
    id: 'course-authoring.unit-page.sidebar.info.sidebar-button-info',
    defaultMessage: 'Info',
    description: 'Label of the button for the Info sidebar',
  },
});

export default messages;
